import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClassName, LexicalTheme, toClassName } from '@dossierhq/design';
import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { LexicalComposer } from '@lexical/react/LexicalComposer.js';
import { ContentEditable } from '@lexical/react/LexicalContentEditable.js';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary.js';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin.js';
import { HeadingNode } from '@lexical/rich-text';
import { useCallback, useContext } from 'react';
import { EntityDisplayDispatchContext } from '../../contexts/EntityDisplayDispatchContext.js';
import { EntityDisplayActions } from '../../reducers/EntityDisplayReducer/EntityDisplayReducer.js';
import { PublishedClickableLinkPlugin } from './PublishedClickableLinkPlugin.js';
import { PublishedComponentNode } from './PublishedComponentNode.js';
import { PublishedEntityLinkNode } from './PublishedEntityLinkNode.js';
import { PublishedEntityNode } from './PublishedEntityNode.js';
import { RichTextDisplayContext } from './RichTextDisplayContext.js';
export function RichTextDisplay({ fieldSpec, value }) {
    const dispatchEntityDisplayState = useContext(EntityDisplayDispatchContext);
    const handleEntityLinkClick = useCallback((reference) => {
        // open entity asynchronously to not fight with the "click to activate entity" functionality
        setTimeout(() => dispatchEntityDisplayState(new EntityDisplayActions.AddEntity(reference.id)));
    }, [dispatchEntityDisplayState]);
    const initialConfig = {
        namespace: 'dossierhq',
        onError: handleError,
        nodes: [
            CodeNode,
            CodeHighlightNode,
            PublishedEntityNode,
            PublishedEntityLinkNode,
            PublishedComponentNode,
            HeadingNode,
            LinkNode,
            ListItemNode,
            ListNode,
        ],
        editable: false,
        theme: LexicalTheme,
        editorState: value
            ? (editor) => {
                const state = editor.parseEditorState(value);
                editor.setEditorState(state);
            }
            : undefined,
    };
    return (_jsx(RichTextDisplayContext.Provider, { value: { fieldSpec }, children: _jsxs(LexicalComposer, { initialConfig: initialConfig, children: [_jsx(RichTextPlugin, { contentEditable: _jsx(ContentEditable, { className: toClassName(ClassName['rich-text'], ClassName['rich-text-editor']) }), placeholder: null, ErrorBoundary: LexicalErrorBoundary }), _jsx(PublishedClickableLinkPlugin, { onClick: handleEntityLinkClick })] }) }));
}
function handleError(error) {
    console.error(error);
}
//# sourceMappingURL=RichTextDisplay.js.map